module.exports = __webpack_public_path__ + "files/02b657b7da043efaab00d8f072dee6d7.png";